<div style="max-width: 630px">
  <div mat-dialog-content>
    <lemon-dialog-header> Määrittele {{ tauko.tyyppi === 'tauko' ? 'tauko' : 'pöytälaatikkokausi' }} </lemon-dialog-header>

    @if (tauko.tyyppi === 'tauko') {
      <p class="dark-gray-text" style="text-align: center">Tauon aikana asiakkaalle ei lähetetä jatkuvia laskuja. Lemonaid-tunnukset ovat asiakkaan käytössä koko kauden ajan rajoitetuin oikeuksin.</p>
    }
    @if (tauko.tyyppi === 'poytalaatikko') {
      <p class="dark-gray-text" style="text-align: center">Pöytälaatikkokauden aikana asiakkaalle ei lähetetä jatkuvia laskuja. Lemonaid-tunnukset ovat asiakkaan käytössä koko kauden ajan rajoitetuin oikeuksin.</p>
    }

    <div style="margin: 0 50px">
      <mat-form-field style="max-width: 200px; margin-left: 10px; margin-right: 10px; margin-bottom: 22px; margin-top: 44px">
        <mat-label>Aloituspvm</mat-label>
        <input #taukoAlkaaInputti type="text" [min]="minimiAlkaaPaivamaara" [matDatepicker]="pickerAlkaa" [formField]="taukoLomake.alkaa" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="pickerAlkaa"></mat-datepicker-toggle>
        @if (naytetaankoVirhe(taukoLomake.alkaa, 'required')) {
          <mat-error> Aloituspäivä puuttuu </mat-error>
        }
        @if (naytetaankoVirhe(taukoLomake.alkaa, 'min')) {
          <mat-error> {{ tauko.tyyppi === 'tauko' ? 'Tauko' : 'Pöytälaatikkokausi' }} ei voi alkaa samaan aikaan tai ennen edellisen loppumista. 1 </mat-error>
        }
        @if (naytetaankoVirhe(taukoLomake.alkaa, 'matDatepickerMin')) {
          <mat-error> {{ tauko.tyyppi === 'tauko' ? 'Tauko' : 'Pöytälaatikkokausi' }} ei voi alkaa samaan aikaan tai ennen edellisen loppumista. 2 </mat-error>
        }
        <mat-datepicker #pickerAlkaa></mat-datepicker>
      </mat-form-field>

      <!-- <pre>{{ taukoFormGroup.get('alkaa')?.errors | json }}</pre> -->

      <mat-form-field style="max-width: 200px; margin-left: 10px; margin-right: 10px; margin-bottom: 22px; margin-top: 44px">
        <mat-label>Lopetuspvm</mat-label>
        <input #taukoLoppuuInputti type="text" [max]="maksimiLoppuuPaivamaara" [matDatepicker]="pickerLoppuu" [formField]="taukoLomake.loppuu" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="pickerLoppuu"></mat-datepicker-toggle>
        @if (naytetaankoVirhe(taukoLomake.loppuu, 'required')) {
          <mat-error> Lopetuspäivä puuttuu </mat-error>
        }
        @if (naytetaankoVirhe(taukoLomake.loppuu, 'min')) {
          <mat-error> {{ tauko.tyyppi === 'tauko' ? 'Tauko' : 'Pöytälaatikkokausi' }} ei voi alkaa samaan aikaan tai ennen edellisen loppumista. 1 </mat-error>
        }
        @if (naytetaankoVirhe(taukoLomake.loppuu, 'matDatepickerMin')) {
          <mat-error> {{ tauko.tyyppi === 'tauko' ? 'Tauko' : 'Pöytälaatikkokausi' }} ei voi alkaa samaan aikaan tai ennen edellisen loppumista. 2 </mat-error>
        }
        <mat-datepicker #pickerLoppuu></mat-datepicker>
      </mat-form-field>

      @if (tauko.tyyppi === 'tauko') {
        <div>
          <mat-form-field style="max-width: 200px; margin-left: 10px; margin-right: 10px; margin-bottom: 22px">
            <mat-label>Muistutuspvm</mat-label>
            <input type="text" [matDatepicker]="pickerMuistutus" [formField]="taukoLomake.muistutuspvm" matInput data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="pickerMuistutus"></mat-datepicker-toggle>
            @if (naytetaankoVirhe(taukoLomake.muistutuspvm, 'required')) {
              <mat-error> Muistutuspäivä puuttuu </mat-error>
            }
            @if (naytetaankoVirhe(taukoLomake.muistutuspvm, 'minDate')) {
              <mat-error> Pvm pitää olla tulevaisuudessa </mat-error>
            }
            <mat-datepicker #pickerMuistutus></mat-datepicker>
          </mat-form-field>
          <i class="icon ion-ios-information-circle-outline info" [matTooltip]="muistutusPvmText" matTooltipShowDelay="100" aria-hidden="true"></i>
          <p class="dark-gray-text" style="margin: 0 10px 22px; font-size: 12px; line-height: 16px">Sisäinen muistutus, ei lähde asiakkaalle. Muistutuspäivänä asiakkaan kohdalle asiakaslistaan ilmestyy punainen kellokuvake.</p>
        </div>
      }
      <!-- <pre>{{ taukoFormGroup.get('loppuu')?.errors | json }}</pre> -->
    </div>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-secondary-button mat-dialog-close actionId="Sopimuskausi tauolle: Peruuta ja sulje dialog">Peruuta</app-secondary-button>
    <app-primary-button (click)="tallenna()" actionId="Sopimuskausi tauolle tai pöytälaatikkoon, tallenna tiedot" [actionContext]="[taukoLomake().value()]">Tallenna</app-primary-button>
  </div>
</div>
